// The account/auth form field renderer now lives in tsi-common-react so the
// shared account document bodies can reuse it (#33285). Re-exported here so the
// other pillows account/auth templates keep importing it from this path
// unchanged.
export { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
